import { thumbImage, useGlobalState, useTrackingService } from '@libs/client'
import { imagePath, moneyConverter } from '@ui/helpers'
import { useSetting } from '@ui/hooks'
import { useEffect } from 'react'
import css from 'styled-jsx/css'
import SfLink from '../next/SfLink'
import Description from '../shared/Description'
import StarRating from '../shared/StarRating'

const sThumb = thumbImage('96x96')
// const mThumb = thumbImage('w=350,h=350')

export default function Catalog() {
  const [catalog] = useGlobalState<S3Types.catalog | null>('store.catalog')
  const [storeSetting] = useSetting('store')
  const { trackingViewItem } = useTrackingService()
  useEffect(() => {
    //TODO: tracking
    trackingViewItem()
  }, [])
  return (
    <div className="ministore-catalog">
      <style jsx global>
        {globalStyle}
      </style>
      <div className="wrapper">
        <div className="page__content section is-max-desktop">
          <h1>{storeSetting?.general?.name} Products</h1>
          {storeSetting?.general?.description && (
            <Description description={storeSetting.general.description} />
          )}
          <div className="stores">
            <div className="columns">
              {catalog &&
                Object.entries(catalog).map(([subpath, item]) => (
                  <div key={subpath} className="column is-12-mobile is-6-tablet is-4-desktop">
                    {item.soldout ? (
                      <a className="store-card inactive">
                        <CatalogItem item={item} />
                      </a>
                    ) : (
                      <SfLink pathName={`/${subpath}`} className="store-card">
                        <CatalogItem item={item} />
                      </SfLink>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const CatalogItem = ({ item }: { item: S3Types.catalog_item }) => {
  return (
    <>
      <figure className="thumbnail">
        <img
          src={sThumb(item.logo ?? '')}
          data-src={(() => {
            const image = item.logo ?? ''
            return imagePath(image)
            // if (image.endsWith('.gif')) {
            // } else {
            //   return mThumb(item.logo ?? '')
            // }
          })()}
          alt=""
          className="lazyload"
        />
      </figure>
      <div className="content">
        <div className="info">
          <StarRating rating={item.review_score} />
          <h3 className="title">{item.title}</h3>
          <div className="price">
            <span className="default">$ {moneyConverter(item.price ?? 0)}</span>
            <span className="compared">$ {moneyConverter(item.compare_price ?? 0)}</span>
          </div>
        </div>
        <div className="view-button">
          <button className="button is-primary">
            <span>{item.soldout ? 'Sold Out' : 'View Product'}</span>
          </button>
        </div>
      </div>
    </>
  )
}

const globalStyle = css.global`
  .ministore-catalog {
    display: block;

    .page__content {
      max-width: 1120px;
      padding-top: 32px;
      padding-bottom: 128px;
    }

    h1 {
      font-weight: 700;
      font-size: 24px;
      line-height: 40px;
      margin-bottom: 8px;
    }

    .stores {
      margin-top: 64px;
    }

    .columns {
      flex-wrap: wrap;
      grid-row-gap: 32px;
    }

    .store-card {
      background-color: #fff;
      border: 1px solid #eaecf0;
      border-radius: 6px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      height: 100%;

      .thumbnail {
        height: 284px;
        overflow: hidden;

        img {
          width: 100%;
          object-fit: cover;
        }
      }

      .content {
        position: relative;
        flex: 1;
      }

      .info {
        padding: 16px 24px 24px;
        transition: opacity 0.2s ease-in-out;
        height: 100%;
        display: flex;
        flex-direction: column;

        .star-rating {
          margin-bottom: 8px;
        }

        .title {
          margin: 0 0 8px;
          font-size: 15px;
          font-weight: normal;
          line-height: 32px;
          color: #657381;
          flex: 1;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .price {
          display: flex;
          align-items: flex-end;

          .default {
            color: #464f5b;
            font-size: 24px;
            font-weight: 600;
            line-height: 40px;
            margin-right: 12px;
          }

          .compared {
            font-size: 18px;
            font-weight: 300;
            line-height: 36px;
            text-decoration-line: line-through;
            color: #939eab;
          }
        }
      }

      .view-button {
        transition: opacity 0.3s ease-in-out;
        position: absolute;
        opacity: 0;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        button {
          height: 48px;
          width: 200px;
          max-width: 90%;
        }
      }

      &:hover {
        .info {
          opacity: 0;
        }

        .view-button {
          opacity: 1;
        }
      }

      &.inactive {
        cursor: default;
        button {
          cursor: default;
        }
      }
    }
  }
`
